<template>
  <el-container class="body_container">
    <!--<el-row class="head_line">直播</el-row>-->
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">律师</el-row>
      <el-row type="flex">
        <el-col>
          <el-form class="search_select" v-model="searchVo" :inline="true" size="small">
            <el-form-item prop="category"  label-width="40px">
              <!--<el-select v-model="searchForm.category" placeholder="请选择" style="width: 100px" @change="change">-->
                <!--<el-option label="律师名字" value="name"></el-option>-->
                <!--&lt;!&ndash;<el-option label="身份证号" value="idcard"></el-option>&ndash;&gt;-->
                <!--<el-option label="所属律所" value="lawFirm"></el-option>-->
              <!--</el-select>-->
              <el-input v-model="searchVo.keyword" placeholder="输入查询内容"  style="width: 180px">
                <el-button  @click="search" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item class="dialog-footer" >
              <el-button type="primary" @click="search">查询</el-button>
              <el-button type="primary" @click="restForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col style="text-align: right;margin-left: 10px" >
          <el-form :model="searchVo" ref="search" :inline="true">
            <el-form-item class="dialog-footer">
            <el-button  @click="add('addLive')" type="primary">添加律师</el-button>
            <!--添加直播弹窗组件 -->
            <add-lawyer ref="addBranch" v-if="addLawyerVisible" :visible.sync="addLawyerVisible" @callFather="reload" :values="lawyerId" :status="status"></add-lawyer>
            </el-form-item>
            <el-form-item class="dialog-footer">
              <el-button  @click="download" >模板下载</el-button>
              <el-button  @click="importData" type="primary">批量导入</el-button>
              <!--添加直播弹窗组件 -->
              <!-- 导入 -->
              <el-dialog title="导入"  style="text-align:left" :visible.sync="dialogImportVisible" :modal-append-to-body="false" width="30%"
                         :close-on-click-modal="false" class="dialog-import">
                <div :class="{'import-content': importFlag === 1, 'hide-dialog': importFlag !== 1}">
                  <el-upload class="upload-demo"
                             :action="importUrl"
                             :name ="name"
                             :data="paramsdata"
                             :headers="myHeaders"
                             :on-preview="handlePreview"
                             :on-remove="handleRemove"
                             :before-upload="beforeUpload"
                             :on-error="uploadFail"
                             :on-success="uploadSuccess"
                             :file-list="fileList"
                             :with-credentials="withCredentials">
                    <el-button size="small" type="primary" :disabled="processing">{{uploadTip}}</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
                  </el-upload>
                </div>
                <div :class="{'import-failure': importFlag === 2, 'hide-dialog': importFlag !== 2}" >
                  <div class="failure-tips">
                    <i class="el-icon-warning"></i>导入失败</div>
                  <div class="failure-reason">
                    <h4>失败原因</h4>
                    <ul>
                      <li v-for="(error,index) in errorResults" :key="index">第{{error.index}}行，错误：{{error.errorInfo}}</li>
                    </ul>
                  </div>
                </div>
              </el-dialog>
              <!-- 导出 -->
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="search_result emp_search_result">
      <el-table :data="lawyers.list">
        <el-table-column prop="name" label="姓名" min-width="90px"></el-table-column>
        <el-table-column prop="code" label="律师证编号" min-width="155px"></el-table-column>
        <!--<el-table-column prop="gender" :formatter="formatterColumn" label="性别" min-width="60px"></el-table-column>-->
        <!--<el-table-column prop="idcard" label="身份证号" min-width="185px"></el-table-column>-->
        <el-table-column prop="mobile" label="手机" min-width="130px"></el-table-column>

        <!--<el-table-column prop="email" label="邮箱" min-width="150px"></el-table-column>-->
        <el-table-column prop="lawFirm" label="所属律协" min-width="150px"></el-table-column>
        <el-table-column prop="practicingInstitution" :show-overflow-tooltip="true" label="所属律所" min-width="150px"></el-table-column>
        <el-table-column label="登录权限" min-width="90px">
          <template slot-scope="scope">
            <!--<el-button size="mini" @click="checkQuote(scope.row)">-->
            <span v-if="searchVo.id === null || searchVo.id === scope.row.associationId">
              <el-switch
                v-model="scope.row.loginDenied"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="0"
                inactive-value="1"
                @change="changeSwitch(scope.row)">
            </el-switch>
            </span>
            <!--</el-button>-->
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="120px">
          <template slot-scope="scope">
            <span v-if="searchVo.id === null || searchVo.id === scope.row.associationId">
              <!--<el-button size="mini" @click="checkQuote(scope.row)">-->
              <i class="el-icon-edit" @click="checkLawyer(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
              &nbsp;
              <el-tooltip class="item" effect="dark" content="重置密码" placement="top">
                <i class="el-icon-setting" @click="resetPassword(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
              </el-tooltip>
              &nbsp;
              <i class="el-icon-delete" @click="delLawyer(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
                <!--</el-button>-->
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="lawyers.rows"
                   :current-page="lawyers.page"
                   layout="prev, pager, next, jumper"
                   :total="lawyers.total">
    </el-pagination>
  </el-container>
</template>

<script>
import Lawyer from './lawyer/Lawyer.vue'
import lawyer from '@/api/lawyer'
import axios from 'axios'
import store from '../../store/index'
export default {
  name: 'Lawyer',
  data () {
    return {
      myHeaders: {Authorization: null},
      value: true,
      status: null,
      lawyerId: null,
      addLawyerVisible: false,
      lawyers: {
        page: 1,
        rows: 15,
        total: 0,
        list: []
      },
      searchVo: {
        keyword: '',
        page: 1,
        rows: 15,
        id: null,
        register: 'y'
      },
      value2: '1',
      // 导入导出
      paramsdata: {
        file: null
      },
      importUrl:'/_/lawyer/uploadLawyer',//后台接口config.admin_url+'rest/schedule/import/'
      importHeaders:{
        enctype:'multipart/form-data'
      },
      name: 'import',
      fileList: [],
      withCredentials: true,
      processing: false,
      uploadTip:'点击上传',
      importFlag:1,
      dialogImportVisible:false,
      errorResults:[]
    }
  },
  methods: {
    checkLawyer (row) {
      this.lawyerId = row.id
      this.status = false
      this.addLawyerVisible = true
    },
    delLawyer (row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        lawyer.del({id: row.id}).then(res => {
          this.$message.info(res.data.message)
          if (res.data.code===0){
            this.reload()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.searchVo.page = val
      this.reload()
    },
    reload () {
      // this.searchVo.id = this.GlobalVariable.assId
      // this.searchVo.page = 1
      // console.log(this.searchVo)
      lawyer.find(this.searchVo).then(res => {
        // console.log(res.data.data)
        this.lawyers = res.data.data
      })
    },
    formatterColumn (row, column) {
      return row.gender === '1' ? '男' : row.gender === '2' ? '女' : ''
    },
    add (refForm) {
      this.status = true
      this.lawyerId = null
      if (this.$refs[refForm]) {
        this.$refs[refForm].initForm()
      }
      this.addLawyerVisible = true
    },
    search () {
      this.searchVo.page = 1
      this.reload()
    },
    restForm () {
      // this.searchForm.category = 'name'
      // this.searchForm.title = ''
      this.searchVo.page = 1
      this.searchVo.keyword = ''
      this.reload()
    },
    // 锁定 修改
    changeSwitch (row) {
      let lok ={
        id: row.id,
        loginDenied: row.loginDenied
      }
      // console.log(lok)
      lawyer.locking(lok).then(res => {
        this.$message.warning(res.data.message)
        this.reload()
      })
    },
    resetPassword (row) {
      this.$confirm('此操作将重置该用户的密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        lawyer.resetPwd({id: row.id}).then(res => {
          this.$message.info(res.data.message)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        });
      });
    },
    updateData (val) {
      this.searchVo.page = val
      this.reload()
    },
    importData() {
      this.errorResults = []
      this.importFlag = 1
      this.fileList = []
      this.uploadTip = '点击上传'
      this.processing = false
      this.dialogImportVisible = true
    },
    handlePreview(file) {
      //可以通过 file.response 拿到服务端返回数据
    },
    handleRemove(file, fileList) {
      //文件移除
    },
    beforeUpload(file){
      //上传前配置
      this.paramsdata.file = file
      let excelfileExtend = ".xls,.xlsx"//设置文件格式
      let fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
      if (excelfileExtend.indexOf(fileExtend) <= -1) {
        this.$message.error('文件格式错误')
        return false
      }
      this.uploadTip = '正在处理中...'
      this.processing = true
    },
    //上传错误
    uploadFail(err, file, fileList) {
      this.uploadTip = '点击上传'
      this.processing = false
      this.$message.error(err)
    },
    //上传成功
    uploadSuccess(response, file, fileList) {
      this.uploadTip = '点击上传'
      this.processing = false
      // console.log(response)
      if (response.code === 10000 || response.code === 9) {
        // console.log(response)
        if (response.hasOwnProperty('data')){
          response.data.forEach( item => {
            let obj = {
              index: item,
              errorInfo: response.message
            }
            this.errorResults.push(obj)
          })
        }else {
          this.errorResults = undefined
        }
      // console.log(this.errorResults)
        if (this.errorResults) {
          this.importFlag = 2
        } else {
          this.dialogImportVisible = false
          this.$message.error(response.message)
        }
      } else {
        this.importFlag = 3
        this.dialogImportVisible = false
        this.$message.info('导入成功')
        this.reload()
      }
    },
    //下载模板
    download () {
      axios({
        method: 'get',
        url:'/lawyer/exportLawyer',
        responseType: 'blob'
      }).then(res => this.downloads(res.data, res.headers.filename))
    },
    // 创建模板下载链接
    downloads (data, name){
      if(!data){
        return
      }
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display ='none'
      link.href = url
      link.setAttribute('download', `批量添加律师模板.xls`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  },
  components: {
    'add-lawyer': Lawyer
  },
  created () {
    this.myHeaders.Authorization = 'Bearer '+store.getters.getToken
    if (store.getters.getAsId ) {
      this.searchVo.id = parseInt(store.getters.getAsId)
    }
    this.reload()
    // if (store.getters.getAsId) {
    //   // console.log( store.getters.getAsId)
    //   this.searchVo.id = store.getters.getAsId
    // }
  }
}
</script>
<style scoped>
  .hide-dialog{
    display:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/lawyer/Lawyer.vue